export default "__VITE_ASSET__CrziPaNz__"